"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnaireType = void 0;
var QuestionnaireType;
(function (QuestionnaireType) {
    QuestionnaireType["BESTFIT"] = "bestfit";
    QuestionnaireType["PROFILE_PAGE"] = "profile_page";
    QuestionnaireType["LOCALIZATION_SETTINGS"] = "localization_settings";
    QuestionnaireType["CONFIRM_NATIONALITY_SETTINGS"] = "confirm_nationality_settings";
    QuestionnaireType["RECOMMENDATIONS"] = "recommendations";
    QuestionnaireType["ONBOARDING"] = "onboarding";
    QuestionnaireType["GLOBAL_ACCESS_INITIATIVE"] = "global_access_initiative";
    QuestionnaireType["START_DATE"] = "start_date";
    QuestionnaireType["SCHOLARSHIPS_ELIGIBILITY"] = "scholarships_eligibility";
    QuestionnaireType["FJS_DISCOVER"] = "fjs_discover";
    QuestionnaireType["STUDY_PREFERENCES"] = "study_preferences";
    QuestionnaireType["BESTFIT_AI"] = "bestfit_ai";
    QuestionnaireType["NOTIFICATION_SETTINGS"] = "notification_settings";
    QuestionnaireType["ACCEPTANCE"] = "acceptance";
})(QuestionnaireType || (exports.QuestionnaireType = QuestionnaireType = {}));
